import { IPredicate } from '@src/models/api';

export const updateDateRangeFilterValue = ({
  predicate,
  setDateTo,
  setDateFrom,
}: {
  predicate: IPredicate[];
  setDateFrom: (date: string) => void;
  setDateTo: (date: string) => void;
}) => {
  const dateFrom = predicate.find((el) => el.operator === 'GREATER_THAN_EQUALS')?.values[0];
  setDateFrom?.(dateFrom);

  const dateTo = predicate.find((el) => el.operator === 'LESS_THAN_EQUALS')?.values[0];
  setDateTo?.(dateTo);
};

export const getDateFiltersUpdate = ({
  predicate,
  dateTo,
  dateFrom,
  filterName = 'startDate',
}: {
  predicate: IPredicate[];
  dateFrom: string;
  dateTo: string;
  filterName?: string;
}) => {
  if (!dateFrom || !dateTo) {
    return predicate.filter(
      (filter) =>
        !(filter.field === filterName && ['GREATER_THAN_EQUALS', 'LESS_THAN_EQUALS'].includes(filter.operator)),
    );
  }

  const noDateFilters = !predicate.find((filter) => filter.field === filterName);

  if (noDateFilters) {
    return [
      ...predicate,
      { field: filterName, operator: 'GREATER_THAN_EQUALS', values: [dateFrom] },
      { field: filterName, operator: 'LESS_THAN_EQUALS', values: [dateTo] },
    ] as IPredicate[];
  }

  return predicate.map((filter) => {
    if (filter.field === filterName) {
      if (filter.operator === 'GREATER_THAN_EQUALS') {
        return { ...filter, values: [dateFrom] };
      } else if (filter.operator === 'LESS_THAN_EQUALS') {
        return { ...filter, values: [dateTo] };
      }
    }
    return filter;
  });
};
